import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { StepComponent } from '../../../classes/abstract-step.component';
import { IStepCheckbox } from '../../../interfaces/step-checkbox.interface';

@Component({
  standalone: false,
  selector: 'app-prior-experience-step',
  templateUrl: './prior-experience-step.component.html',
  styleUrls: ['../../../styles/step.styles.scss', './prior-experience-step.component.scss'],
})
export class PriorExperienceStepComponent extends StepComponent {
  @Input() readonly parentFormGroup: FormGroup;
  @Input() readonly controlName: string;

  readonly formGroup = new FormGroup({});

  readonly checkboxes: IStepCheckbox[] = [
    {
      name: 'hasUsedECommerce',
      label: 'I have used E-commerce systems before.',
    },
    {
      name: 'hasUsedBI',
      label: 'I have used BI systems before.',
    },
  ];
}
